<template>
    <ShadowBoxContainer>

        <CardShell class="col-sm-9 center mt4-ns">
            <!-- page heading -->
            <ListHeader :hasCancel="true" class="ph3 ph4-ns"
                :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
                imageLabel="Edit Listing Menu"
                heading="Quickly jump anywhere to edit your listing."
            />
            <router-link v-for="(page, index) in pages" :key="index" :to="'/' + page.route" class="black no-underline">
                <WhiteCategory  :categoryName="page.name" :hasChild="true"/>
            </router-link>
        </CardShell>

        <!-- buttons -->
        <template slot="actionBar">
            <EditListingFooter class="col-xs-12 col-sm-6 col-sm-offset-3" back="fsda" forward="Next" backLink="/deposit"/>
        </template>

    </ShadowBoxContainer>
</template>

<script>
const PAGES = [
    { name: 'Title', route: 'listing-start' },
    { name: 'Category', route: 'category' },
    { name: 'Brand', route: 'brand' },
    { name: 'Photos', route: 'add-photos' },
    { name: 'Description', route: 'description' },
    { name: 'Location', route: 'pickup-address' },
    { name: 'Delivery', route: 'owner-delivery' },
    { name: 'Rates', route: 'rates' },
    { name: 'Refundable deposit', route: 'deposit' },
    { name: 'Additional fees', route: 'additional-fees' }
];

import NavigationButtons from '@/components/global/NavigationButtons.vue';
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import CardShell from '@/components/global/CardShell.vue';
import ListHeader from '@/components/list/shared/ListHeader.vue';
import LabeledControl from '@/components/controls/LabeledControl.vue';
import CurrencyInput from '@/components/controls/CurrencyInput.vue';
import AddFees from '@/components/list/additionalFees/AddFees.vue';
import WhiteCategory from '@/components/list/shared/WhiteCategory.vue';
import EditListingFooter from '@/components/editListing/EditListingFooter.vue';

export default {
    components: {
        NavigationButtons,
        ShadowBoxContainer,
        CardShell,
        ListHeader,
        CurrencyInput,
        LabeledControl,
        AddFees,
        WhiteCategory,
        EditListingFooter
    },
    data() {
        return {
            pages: PAGES
        };
    }
};
</script>
